import React from 'react'
import { Container, Footer } from './styles';
import { Modal } from '../ModalInfo/styles';

const ModalInformativo = ({ onClose = () => { }, handleModalStorage = () => { }, children, title, buttonText, MessageInline }) => {
  return (
    <Modal>
      <Container >
        <button onClick={onClose}>X</button>
        <h1>{title}</h1>
        <br />
        <p>{children}</p>
        <Footer>
          <div>
            <button onClick={onClose}>{buttonText}</button>
            <p onClick={handleModalStorage}>{MessageInline}</p>
          </div>
        </Footer>
      </Container>
    </Modal>
  );
}

export default ModalInformativo;